import "@/App.css";
import { Header } from "@/components/Header";
import { ServerCard } from "@/components/ServerCard";
import { StatCounter } from "@/components/StatCounter";
import { SERVERS, DISCORD_URL } from "@/data/servers";
import { MessageSquare } from "lucide-react";

function App() {
  return (
    <div className="dz-root min-h-screen" data-testid="server-selector-page">
      <div className="dz-grain" aria-hidden="true" />
      <Header />
      <main className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pt-28 pb-16">
        <section className="mb-12 max-w-3xl dz-fade" data-testid="hero-section">
          <p className="dz-mono text-xs uppercase tracking-[0.3em] text-[#e02424] mb-4">
            // Comunidade DayZ Brasil
          </p>
          <h1 className="dz-heading text-4xl sm:text-5xl lg:text-6xl font-black uppercase leading-[0.95] text-zinc-100">
            Escolha seu campo de <span className="text-[#e02424]">sobrevivência</span>
          </h1>
          <p className="mt-5 text-sm sm:text-base text-zinc-400 max-w-xl leading-relaxed">
            Dois mapas, uma comunidade. Selecione o servidor em que deseja jogar e siga
            direto para o site oficial.
          </p>
          <p
            className="mt-6 pl-4 border-l-2 border-[#e02424] text-sm sm:text-base text-zinc-200 max-w-2xl leading-relaxed"
            data-testid="community-text"
          >
            Há mais de 5 anos, a BRASIL+ reúne sobreviventes em experiências únicas no DayZ. Com mais de 9 mil membros, nossa comunidade continua crescendo, evoluindo e oferecendo novos desafios em Chernarus e Nasdara.
          </p>
          <div className="mt-8 flex gap-10 sm:gap-14" data-testid="stats-section">
            <StatCounter value={5} suffix="+" label="Anos de comunidade" testId="stat-years" />
            <StatCounter value={9} suffix=" mil" label="Membros" testId="stat-members" />
          </div>
        </section>
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8" data-testid="server-list">
          {SERVERS.map((s, i) => (
            <ServerCard key={s.id} server={s} index={i} />
          ))}
        </section>
      </main>
      <footer className="relative z-10 border-t border-white/5">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 flex flex-col sm:flex-row gap-4 items-start sm:items-center justify-between">
          <p className="dz-mono text-xs text-zinc-500 uppercase tracking-widest" data-testid="footer-copyright">
            © {new Date().getFullYear()} BRASIL+
          </p>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-discord-link"
            className="dz-mono text-xs uppercase tracking-widest text-zinc-400 hover:text-[#5865F2] transition-colors flex items-center gap-2"
          >
            <MessageSquare size={14} /> discord.gg/MASTERKR
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
